/**
 * `solution_detail_page` block renderer.
 *
 * Wraps the existing `<SolutionDetailPage>` component so pages like /advance
 * and /aether can be edited through the block-based CMS while preserving the
 * exact visual output (sticky lead form, alternating section stripes, stats
 * band, workflow strip, why-choose grid, and the final dark-sky CTA).
 *
 * Data shape mirrors the `data` prop of SolutionDetailPage. SEO is handled at
 * the CMS page level (page.seo_title/seo_description/seo_keywords) — the
 * `seo` sub-object should NOT be included in the block data to avoid a
 * duplicate <Seo> tag being rendered.
 */
import SolutionDetailPage from "@/pages/solutions/SolutionDetailPage";

export default function SolutionDetailPageBlock({ data }) {
  if (!data || typeof data !== "object") return null;
  // Defensive strip: if a legacy payload includes `seo`, drop it so the
  // BlockRendererPage's own <Seo> tag stays the single source.
  const { seo: _ignoredSeo, ...rest } = data;
  return <SolutionDetailPage {...rest} />;
}
